import httpManager from "../../../utils/httpManager";

export async function fetchAvailableChannels({ toSequence = false, skipFilterQueue = false } = {}) {
  const url = `/channels/channel-customer/available?to_sequence=${toSequence}&skip_filter_queue=${skipFilterQueue}`;
  const response = await httpManager.get(url);
  return response.data || [];
}
